export default {
    SET_ISSUES(state, val) {
        state.issues = val;
    }
};
